import { extend } from 'flarum/extend';
import app from 'flarum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import Swiper from 'swiper/bundle';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

/**
 *  图片轮播
 */
export default function headerCarousel() {
  extend(IndexPage.prototype, 'view', function (vnode) {
    const isSwiper = app.forum.attribute('swiper-enabled') === '1';
    const slidesSetting = app.forum.attribute('swiper_slides');
    const tag = this.currentTag();

    // 如果不是首页，直接返回，不渲染轮播图
    if (tag || !isSwiper || !slidesSetting || slidesSetting.length === 0) return;

    const slides = slidesSetting.sort((a, b) => a.order - b.order) || [];

    const imgBox = m('div',{
      id: 'my-swiper-container',class: "container",
    },[
      m('div',{ class: 'swiper swiper-box'},[
        m('div', { class: 'swiper-wrapper' }, [
          slides.map((slide, index) =>
            slide.image ? (
              m('div', { class: 'swiper-slide' }, [
                m('a', { href: slide?.link || "", target: '_blank' }, [
                  m('img', { src: slide.image?.url })
                ])
              ])
            ) : ""
          ),
        ]),
        m('div', { class: 'swiper-pagination' }),
        m('div', { class: 'swiper-button-prev' }),
        m('div', { class: 'swiper-button-next' }),
      ]),
    ]);
    vnode.children.unshift(imgBox);
  });

  extend(IndexPage.prototype, 'oncreate', function (vnode) {
    const tag = this.currentTag();

    // 如果不是首页，直接返回，不渲染轮播图
    if (tag) return;

    const welcomeHero = document.getElementsByClassName('Hero WelcomeHero');
    new Swiper(document.querySelector('.swiper-box'), {
      modules: [Navigation, Pagination, Autoplay],
      loop: app.forum.attribute('swiper_loop'),
      autoplay: {
        delay: app.forum.attribute('swiper_autoplay_delay'), // 每个 slide 停留时间 (单位：毫秒)
        disableOnInteraction: false, // 用户交互后是否停止自动播放
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
    // 图片轮播显示时，默认的头部隐藏
    if (app.current.matches(IndexPage)) {
      for (var i = 0; i < welcomeHero.length; i++) {
        welcomeHero[i].style.display = 'none';
      }
    }
  });
}
